import { createUseStyles } from 'react-jss'

const useStyles = createUseStyles({
  excludeLocationsCheckbox: {
    marginTop: ['0px', '!important'],
    marginLeft: ['0px', '!important']
  }
})

export default useStyles
